import { Link } from 'react-router-dom-v5-compat';

import {
  CheckMetadataItemType,
  GroupedCheckMetadataItem,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import {
  THRESHOLD_EXACT_MATCH_FACE,
  THRESHOLD_VERY_HIGH_FACE,
} from 'dashboard/lib/constants/similarity-selfie';
import { SelfieRepeatDetection } from 'dashboard/models/check';
import Sticker from 'design-system/components/Sticker';

export const computeSelfieRepeatDetectionMetadata = (check: SelfieRepeatDetection) => {
  const metadataItems: GroupedCheckMetadataItem[] =
    check.metadata?.matches?.map((match, index) => {
      return {
        type: CheckMetadataItemType.Group,
        heading: { title: `Match ${index + 1}` },
        items: [
          {
            label: 'Name',
            type: CheckMetadataItemType.Simple,
            value: match['name'] || 'No name',
          },
          match['account-id']
            ? {
                label: 'Account ID',
                type: CheckMetadataItemType.Simple,
                value: (
                  <Link to={`/dashboard/accounts/${match['account-id']}`}>
                    {match['account-id']}
                  </Link>
                ),
              }
            : null,
          {
            label: 'Reference ID',
            type: CheckMetadataItemType.Simple,
            value: match['reference-id'] || '-',
          },
          match.confidence > 0
            ? {
                label: 'Confidence',
                type: CheckMetadataItemType.Simple,
                value: confidenceSticker(match.confidence),
              }
            : null,
        ].filter((item) => item != null),
      };
    }) || [];

  return {
    metadata: metadataItems,
    // If passed but no metadata, hide the metadata section
    hideIfVerificationPassed: metadataItems.length === 0,
  };
};

function confidenceSticker(confidence: number) {
  if (confidence >= THRESHOLD_EXACT_MATCH_FACE) {
    return <Sticker variant='danger'>Exact Match</Sticker>;
  } else if (confidence > THRESHOLD_VERY_HIGH_FACE) {
    return <Sticker variant='orange'>Very High</Sticker>;
  } else {
    return <Sticker variant='caution'>High</Sticker>;
  }
}
